import {
  Karte,
  PopulationDataType,
  Format,
  Category,
  ValueType,
  City,
  CityDataType,
  SupportCategoryType
} from './types';

export function getKarteTemplate(city: City) {
  const template: Karte[][] = [
    [
      {
        category: Category.Ku,
        city: city,
        area: city,
        populationDataType: PopulationDataType.Total,
        cityDataType: undefined,
        valueType: ValueType.Amount,
        year: 2018,
        format: Format.Map,
        support: SupportCategoryType.lSupportNeed_1
      },
      {
        category: Category.Ku,
        city: city,
        area: city,
        populationDataType: PopulationDataType.Total,
        cityDataType: undefined,
        valueType: ValueType.Amount,
        year: undefined,
        format: Format.LineChart,
        support: SupportCategoryType.lSupportNeed_1
      },
      {
        category: Category.Ku,
        city: city,
        area: city,
        populationDataType: PopulationDataType.Total,
        cityDataType: undefined,
        valueType: ValueType.Proportion,
        year: undefined,
        format: Format.LineChart,
        support: SupportCategoryType.lSupportNeed_1
      }
    ],
    [
      {
        category: Category.Ku,
        city: city,
        area: city,
        populationDataType: PopulationDataType.Less15,
        cityDataType: undefined,
        valueType: ValueType.Amount,
        year: undefined,
        format: Format.LineChart,
        support: SupportCategoryType.lSupportNeed_1
      },
      {
        category: Category.Ku,
        city: city,
        area: city,
        populationDataType: PopulationDataType.Less15,
        cityDataType: undefined,
        valueType: ValueType.Proportion,
        year: undefined,
        format: Format.LineChart,
        support: SupportCategoryType.lSupportNeed_1
      },
      {
        category: Category.Ku,
        city: city,
        area: city,
        populationDataType: PopulationDataType.Over65,
        cityDataType: undefined,
        valueType: ValueType.Amount,
        year: undefined,
        format: Format.LineChart,
        support: SupportCategoryType.lSupportNeed_1
      },
      {
        category: Category.Ku,
        city: city,
        area: city,
        populationDataType: PopulationDataType.Over65,
        cityDataType: undefined,
        valueType: ValueType.Proportion,
        year: undefined,
        format: Format.LineChart,
        support: SupportCategoryType.lSupportNeed_1
      }
    ],
    [
      {
        category: Category.Ku,
        city: city,
        area: city,
        populationDataType: undefined,
        cityDataType: CityDataType.NursingCare,
        valueType: ValueType.Amount,
        year: undefined,
        format: Format.BarChart,
        support: SupportCategoryType.lSupportNeed_1
      }
    ]
  ];
  return template;
}
